import React from "react";
import { Flex, Image } from "theme-ui";

interface GoodsFooterButtonProps {
  icon?: string;
  text: string;
  onClick: () => void;
}

function GoodsFooterButton({
  icon,
  text,
  onClick,
}: GoodsFooterButtonProps) {
  return (
    <Flex
      sx={{
        alignItems: "center",
        backgroundColor: "primaryLight",
        borderTop: "0px solid",
        borderTopColor: "#000",
        bottom: 0,
        color: "#fff",
        fontSize: "17px",
        height: "50px",
        justifyContent: "center",
        left: 0,
        position: "fixed",
        textAlign: "center",
        width: "100%",
      }}
      onClick={onClick}
    >
      {icon && (
        <Image
          src={icon}
          sx={{ height: "22px", marginRight: "7px", width: "19px" }}
        />
      )}
      {text}
    </Flex>
  );
}

export default GoodsFooterButton;
